import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes/plugins/object-fit/ls.object-fit'
import { appendScript } from '@helper/helpers'

/**
 * Lazy loading implementation for Devslab
 * @param {Document|HTMLElement=} el Any element that may contain images to be lazyloaded.
 * @see {@link https://web.dev/browser-level-image-lazy-loading/}
 * @see {@link https://app.asana.com/0/1199881138945091/1201629710018200}
 */
export const lazyLoading = (el = document) => {
  /** @type {HTMLImageElement[]} All images in `DOM` */
  const images = Array.from(el.querySelectorAll('img[loading="lazy"]'))

  images?.forEach(img => {
    /** Replace the native attribute with a class */
    img.classList.add('lazyload')

    /** Remove the native attribute */
    img.removeAttribute('loading')
  })

  /** @type {string} In inc/assets.php we define where the Polyfill-JavaScript for Lazysizes should be placed. */
  // eslint-disable-next-line
  const lazySizesPath = DevslabData.lazySizesPath
  if (!lazySizesPath) {
    throw Error("Missing required argument 'window.lazySizesPath'")
  }

  appendScript(lazySizesPath, 'lazy-polyfill')

  /**
   * Add lazyload for images
   * @see {@link https://github.com/aFarkas/lazysizes/}
   */
  window.lazySizesConfig = window.lazySizesConfig || {}

  /**
   * The expFactor is used to calculate the "preload expand", by multiplying the normal expand with the expFactor which is used to preload
   * assets while the browser is idling (no important network traffic and no scrolling).
   * (Reasonable values are between 1.5 and 4 depending on the expand option. Default: 1.5)
   */
  window.lazySizesConfig.expFactor = 4

  /**
   * The hFac (horizontal factor) modifies the horizontal expand by multiplying the expand value with the hFac value.
   * Use case: In case of carousels there is often the wish to make the horizontal expand narrower than the normal vertical expand option.
   * (Reasonable values are between 0.4 - 1. Default: 0.8)
   */
  window.lazySizesConfig.hFac = 0.4
  // }
}
